import { render } from "./Full.vue?vue&type=template&id=20e6e3d0"
import script from "./Full.vue?vue&type=script&lang=js"
export * from "./Full.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\admin.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__